import { ImmHelper } from "@base/util/Immutable";
import { PartialRecord } from "@base/util/TypeUtil";
import { OrderType } from "@biz/Definitions";
import { ProductData3d } from "@biz/definitions/IVariantData3d";
import { IProduct2dForm } from "@biz/models/Sail2dDefinitions";
import { SCProductData } from "@biz/sc/IShopData";

export function getSlotReducer<T extends { articleSlots: PartialRecord<string, string> }>(): <P extends keyof T["articleSlots"]>(old: T, name: P, articleId: T["articleSlots"][P]) => T {
  const setProductSlot = <P extends keyof (T["articleSlots"])>(old: T, name: P, articleId: T["articleSlots"][P]): T => {
    return ImmHelper.setProperty(old, "articleSlots", name, articleId);
  }
  return setProductSlot;
}

export function getProductReducers<T extends (IProduct2dForm | ProductData3d | SCProductData)>(): { setOrderType(old: T, orderType: OrderType): T; } {
  return {
    setOrderType(old: T, orderType: OrderType): T {
      return { ...old, orderType }
    }
  }
}

